import React from 'react';
import { connect } from 'react-redux';
import LANGUAGES_CONTROLLER from '../../../controllers/languages';
import Logger, { LOG_LEVELS } from '../../../utils/logger';
import { SSelect } from '@avalara/skylab-sdk/react';

const log = new Logger('LISTING_TYPE_SELECTOR', LOG_LEVELS.DEBUG);

export class ListingTypeSelector extends React.Component {

  onChange(event) {
      const newValue = event.detail.item.value;
      if(this.props.onChange) {
        this.props.onChange(newValue);
      }
  }

  render() {
    log.debug('render(): ', this.props);

    const optionsList = this.props.options.map((option, index) => ({
      key: option.value + '',
      value: option.value + '',
      label: option.label,
      selected: this.props.value + '' === option.value + '',
      disabled: option.disabled
    }));

    return (
      <SSelect
        inputId={`listing-type-selector-${this.props.value || 'default'}`}
        optionsList={optionsList}
        multiple={false}
        onS-select={this.onChange.bind(this)}
      />
    );
  }
}

function mapStateToProps(state) {
  log.debug('mapStateToProps: ', state);
  return {
    languages: state.languages
  };
}


ListingTypeSelector.defaultProps = {
  //TODO: Remove default hardcoded values
  options: [
    // {value: '', label: 'Select EC type' },
    // {value: 'EC Goods', label: 'EC Goods' },
    // {value: 'Triangulation', label: 'Triangulation' },
    // {value: 'EC Servoces = art. 196', label: 'EC Servoces = art. 196' }
  ],
  value: '',
  onChange: () => {}
}

export default connect(mapStateToProps)(ListingTypeSelector);
